{
    "schemaVersion": 1,
    "id": "core",
    "name": "The Castle (core pack)",
    "version": "0.1.0",
    "familySafe": true,
    "missions": [
        {
            "id": "tower-of-trust",
            "title": "Tower of Trust",
            "family": "build",
            "summary": "Pairs build the tallest free-standing tower they can. One partner is blindfolded and does all the building.",
            "steps": [
                "Scavenge: cups, books, tins or boxes",
                "Blindfold the builder; the guide may only speak",
                "Build for 90 seconds",
                "Hands off — towers must stand for 5 seconds"
            ],
            "durationSec": 90,
            "scavengeSec": 75,
            "objects": [
                "cups",
                "books",
                "tins",
                "boxes",
                "a scarf for a blindfold"
            ],
            "minPlayers": 4,
            "teamSize": 2,
            "space": "room",
            "noise": "lively",
            "remoteSafe": true,
            "seatedAlternative": "Build on a coffee table while seated; the guide sits opposite.",
            "sabotage": [
                "fake-instruction",
                "time-steal"
            ],
            "potValue": 2000,
            "tags": [
                "blindfold",
                "pairs"
            ]
        },
        {
            "id": "the-ferry",
            "title": "The Ferry",
            "family": "relay",
            "summary": "Carry a spoonful of water across the room, passing it hand to hand without spilling.",
            "steps": [
                "Scavenge: one spoon each and a cup of water",
                "Line up across the room",
                "Pass the water spoon to spoon until the cup at the far end is filled",
                "The phone measures the time; the Steward judges the cup"
            ],
            "durationSec": 120,
            "scavengeSec": 60,
            "objects": [
                "a spoon each",
                "two cups",
                "water",
                "a tea towel"
            ],
            "minPlayers": 4,
            "teamSize": null,
            "space": "room",
            "noise": "loud",
            "remoteSafe": true,
            "seatedAlternative": "Sit in a circle and pass dried rice or lentils instead of water.",
            "sabotage": [
                "hidden-penalty"
            ],
            "potValue": 1500,
            "tags": [
                "relay",
                "whole-group"
            ]
        },
        {
            "id": "the-map-room",
            "title": "The Map Room",
            "family": "communication",
            "summary": "One player sees a secret drawing on their phone and describes it; their partner draws it on paper.",
            "steps": [
                "Scavenge: paper and a pen",
                "The describer sees the map; the drawer may not see the screen",
                "Describe for 60 seconds — no pointing, no shapes in the air",
                "Hold drawings up to the TV for the reveal"
            ],
            "durationSec": 60,
            "scavengeSec": 30,
            "objects": [
                "paper",
                "a pen"
            ],
            "minPlayers": 4,
            "teamSize": 2,
            "space": "sofa",
            "noise": "quiet",
            "remoteSafe": true,
            "seatedAlternative": "Already seated.",
            "sabotage": [
                "fake-instruction"
            ],
            "potValue": 1500,
            "tags": [
                "pairs",
                "drawing"
            ]
        },
        {
            "id": "the-portrait-gallery",
            "title": "The Portrait Gallery",
            "family": "memory",
            "summary": "The TV shows twelve everyday objects for ten seconds. Teams race to gather the same objects from the house.",
            "steps": [
                "Watch the TV for 10 seconds — no phones",
                "Split into teams",
                "Gather as many matching objects as you can in 90 seconds",
                "Lay them out for the TV to count"
            ],
            "durationSec": 90,
            "scavengeSec": 0,
            "objects": [
                "anything in the house"
            ],
            "minPlayers": 4,
            "teamSize": null,
            "space": "house",
            "noise": "loud",
            "remoteSafe": true,
            "seatedAlternative": "Seated players list the objects from memory on their phone instead of fetching them.",
            "sabotage": [
                "fake-instruction",
                "time-steal"
            ],
            "potValue": 2500,
            "tags": [
                "memory",
                "teams"
            ]
        },
        {
            "id": "the-locked-box",
            "title": "The Locked Box",
            "family": "hidden-info",
            "summary": "Each player holds one digit of the code on their phone. Together they must open the box — but an Unfaithful's digit may be false.",
            "steps": [
                "Each phone shows one digit and its position",
                "Talk it through: share digits out loud, but never show your screen",
                "Agree the full code and enter it on the Host's phone",
                "Three wrong guesses and the box seals forever"
            ],
            "durationSec": 180,
            "scavengeSec": 0,
            "objects": [],
            "minPlayers": 4,
            "teamSize": null,
            "space": "sofa",
            "noise": "lively",
            "remoteSafe": true,
            "seatedAlternative": "Already seated.",
            "sabotage": [
                "false-digit"
            ],
            "potValue": 3000,
            "tags": [
                "deduction",
                "whole-group"
            ]
        }
    ],
    "diaryPrompts": [
        {
            "id": "watching-tonight",
            "text": "Who are you watching tonight, and why?",
            "moment": "before-round-table"
        },
        {
            "id": "nice-suspect",
            "text": "Say something nice about someone you suspect.",
            "moment": "any"
        },
        {
            "id": "lie-to-camera",
            "text": "Lie to the camera about one thing. We'll find out which.",
            "moment": "any"
        },
        {
            "id": "mission-hero",
            "text": "Who carried that mission? Who dragged their feet?",
            "moment": "after-mission"
        },
        {
            "id": "too-quiet",
            "text": "Who has been suspiciously quiet?",
            "moment": "before-round-table"
        },
        {
            "id": "trust-one",
            "text": "If you could trust only one person here, who would it be?",
            "moment": "any"
        },
        {
            "id": "gut-feeling",
            "text": "Your gut says… go.",
            "moment": "any"
        },
        {
            "id": "mission-moment",
            "text": "What was the most suspicious moment of that mission?",
            "moment": "after-mission"
        },
        {
            "id": "frame-someone",
            "text": "Frame someone in under 10 seconds. Make it convincing.",
            "audience": "traitor",
            "moment": "before-round-table"
        },
        {
            "id": "act-natural",
            "text": "Act natural. Tell us how much you love the Faithful.",
            "audience": "traitor",
            "moment": "any"
        },
        {
            "id": "promise",
            "text": "Make a promise to the castle you intend to keep.",
            "audience": "faithful",
            "moment": "any"
        },
        {
            "id": "message-to-traitors",
            "text": "Send a message to the Unfaithful. They're watching.",
            "audience": "faithful",
            "moment": "before-round-table"
        },
        {
            "id": "sealed-confess",
            "text": "Sealed until the end. Confess: what was your best lie today?",
            "audience": "traitor",
            "moment": "any",
            "sealed": true
        },
        {
            "id": "sealed-next",
            "text": "Sealed until the end. Who are you coming for next, and why?",
            "audience": "traitor",
            "moment": "any",
            "sealed": true
        },
        {
            "id": "sealed-close-call",
            "text": "Sealed until the end. Who nearly caught you today?",
            "audience": "traitor",
            "moment": "any",
            "sealed": true
        },
        {
            "id": "sealed-guess",
            "text": "Sealed until the end. Name the Unfaithful. We'll see if you were right.",
            "audience": "faithful",
            "moment": "any",
            "sealed": true
        },
        {
            "id": "sealed-regret",
            "text": "Sealed until the end. Who do you think you've got completely wrong?",
            "audience": "faithful",
            "moment": "any",
            "sealed": true
        }
    ],
    "stewardLines": [
        {
            "id": "opened-1",
            "cue": "castle.opened",
            "text": "The gates are open. Enter, if you dare.",
            "tone": "grand"
        },
        {
            "id": "opened-2",
            "cue": "castle.opened",
            "text": "The castle stirs. It has been expecting you.",
            "tone": "ominous"
        },
        {
            "id": "arrival-1",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Do try to stay alive.",
            "tone": "dry"
        },
        {
            "id": "arrival-2",
            "cue": "lobby.arrival",
            "text": "{name} arrives. Trustworthy face. Too trustworthy?",
            "tone": "playful"
        },
        {
            "id": "arrival-3",
            "cue": "lobby.arrival",
            "text": "Arriving late, as expected… {name}.",
            "tone": "dry"
        },
        {
            "id": "arrival-4",
            "cue": "lobby.arrival",
            "text": "{name}. The portraits are already whispering about you.",
            "tone": "ominous"
        },
        {
            "id": "arrival-5",
            "cue": "lobby.arrival",
            "text": "Ah, {name}. We saved you the draughty room.",
            "tone": "playful"
        },
        {
            "id": "arrival-6",
            "cue": "lobby.arrival",
            "text": "{name} is here. Somebody hide the good silver.",
            "tone": "playful"
        },
        {
            "id": "arrival-7",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Your room has a lovely view of the moat. The moat has a lovely view of you, too.",
            "tone": "ominous"
        },
        {
            "id": "arrival-8",
            "cue": "lobby.arrival",
            "text": "{name} has arrived, smiling. We'll see how long that lasts.",
            "tone": "dry"
        },
        {
            "id": "arrival-9",
            "cue": "lobby.arrival",
            "text": "Good evening, {name}. Do wipe your feet. The last guest didn't, and look what happened to them.",
            "tone": "dry"
        },
        {
            "id": "arrival-10",
            "cue": "lobby.arrival",
            "text": "{name}. The castle never forgets a face, and it's already suspicious of yours.",
            "tone": "ominous"
        },
        {
            "id": "arrival-11",
            "cue": "lobby.arrival",
            "text": "Ah, {name}. A fresh face. The castle does love a fresh face.",
            "tone": "ominous"
        },
        {
            "id": "arrival-12",
            "cue": "lobby.arrival",
            "text": "{name} walks in like they own the place. Interesting.",
            "tone": "dry"
        },
        {
            "id": "arrival-13",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Breakfast is at eight. Surviving until then is up to you.",
            "tone": "dry"
        },
        {
            "id": "arrival-14",
            "cue": "lobby.arrival",
            "text": "{name} is here. The ravens have been informed.",
            "tone": "ominous"
        },
        {
            "id": "arrival-15",
            "cue": "lobby.arrival",
            "text": "{name}. Did anyone see you come in? No? Good.",
            "tone": "playful"
        },
        {
            "id": "arrival-16",
            "cue": "lobby.arrival",
            "text": "{name} arrives with an honest face. We'll be the judge of that.",
            "tone": "dry"
        },
        {
            "id": "arrival-17",
            "cue": "lobby.arrival",
            "text": "{name}. Mind the stairs. And the people on them.",
            "tone": "dry"
        },
        {
            "id": "arrival-18",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. The beds are soft, the walls are thin, and everybody's listening.",
            "tone": "ominous"
        },
        {
            "id": "arrival-19",
            "cue": "lobby.arrival",
            "text": "{name} is in. Count your friends now, while you still can.",
            "tone": "ominous"
        },
        {
            "id": "arrival-20",
            "cue": "lobby.arrival",
            "text": "Ah, {name}. The suit of armour in the hall just winked at you. It's never done that before.",
            "tone": "playful"
        },
        {
            "id": "arrival-21",
            "cue": "lobby.arrival",
            "text": "{name} has arrived. Somewhere upstairs, a candle flickers nervously.",
            "tone": "ominous"
        },
        {
            "id": "arrival-22",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Leave your secrets at the door. We'll find them anyway.",
            "tone": "dry"
        },
        {
            "id": "arrival-23",
            "cue": "lobby.arrival",
            "text": "{name}. Lovely to see you. Let's hope it isn't the last time.",
            "tone": "ominous"
        },
        {
            "id": "arrival-24",
            "cue": "lobby.arrival",
            "text": "{name} walks in. The dog growled. The dog never growls.",
            "tone": "playful"
        },
        {
            "id": "arrival-25",
            "cue": "lobby.arrival",
            "text": "{name} is here, and already eyeing up the exits. Sensible.",
            "tone": "dry"
        },
        {
            "id": "arrival-26",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Every guest is innocent until somebody points at them.",
            "tone": "dry"
        },
        {
            "id": "arrival-27",
            "cue": "lobby.arrival",
            "text": "{name} has arrived. Act natural. No, more natural than that.",
            "tone": "playful"
        },
        {
            "id": "arrival-28",
            "cue": "lobby.arrival",
            "text": "Good evening, {name}. Your name is on the guest list. And, for now, nowhere else.",
            "tone": "ominous"
        },
        {
            "id": "arrival-29",
            "cue": "lobby.arrival",
            "text": "{name}: fashionably late, or tactically late? We'll find out.",
            "tone": "playful"
        },
        {
            "id": "arrival-30",
            "cue": "lobby.arrival",
            "text": "{name}. This castle has a hundred rooms, and every one of them has ears.",
            "tone": "ominous"
        },
        {
            "id": "arrival-31",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Help yourself to the wine. It's probably fine.",
            "tone": "playful"
        },
        {
            "id": "arrival-32",
            "cue": "lobby.arrival",
            "text": "{name} has joined us. The odds just changed. Not sure for whom.",
            "tone": "dry"
        },
        {
            "id": "arrival-33",
            "cue": "lobby.arrival",
            "text": "Ah, {name}. You look like someone who can keep a secret. Can you?",
            "tone": "dry"
        },
        {
            "id": "arrival-34",
            "cue": "lobby.arrival",
            "text": "{name} is here. Somebody in this room has already decided whether to trust them.",
            "tone": "ominous"
        },
        {
            "id": "arrival-35",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Unpack lightly. Some guests leave sooner than planned.",
            "tone": "ominous"
        },
        {
            "id": "arrival-36",
            "cue": "lobby.arrival",
            "text": "{name} steps in from the cold. It isn't much warmer in here.",
            "tone": "dry"
        },
        {
            "id": "arrival-37",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Sit anywhere. Except there. Someone's been sitting there for three hundred years.",
            "tone": "playful"
        },
        {
            "id": "arrival-38",
            "cue": "lobby.arrival",
            "text": "{name} has arrived. Somewhere in the shadows, a hood turns to look.",
            "tone": "playful"
        },
        {
            "id": "arrival-39",
            "cue": "lobby.arrival",
            "text": "{name}. Bold of you to come back. Oh, you've never been? Strange. The staff remember you.",
            "tone": "ominous"
        },
        {
            "id": "arrival-40",
            "cue": "lobby.arrival",
            "text": "Welcome, {name}. Smile for the portraits. They never forget a face either.",
            "tone": "playful"
        },
        {
            "id": "departure-1",
            "cue": "lobby.departure",
            "text": "{name} has fled the castle. Wise, perhaps.",
            "tone": "dry"
        },
        {
            "id": "departure-2",
            "cue": "lobby.departure",
            "text": "And just like that, {name} is gone.",
            "tone": "ominous"
        },
        {
            "id": "bell-1",
            "cue": "sync.bell",
            "text": "The bell tolls for all of you.",
            "tone": "grand"
        },
        {
            "cue": "game.begin",
            "text": "Good evening. I am {host}, and this castle is mine. Tonight, {count} of you arrived as friends. {traitors_line}",
            "tone": "grand",
            "id": "host-game-begin-any-1"
        },
        {
            "cue": "game.begin",
            "text": "{count} guests. One fortune. And somewhere among you, {traitors_line_lower}",
            "tone": "grand",
            "id": "host-game-begin-any-2"
        },
        {
            "cue": "game.begin",
            "text": "Welcome to my castle. Look around the room. Somebody you trust is lying to you already.",
            "tone": "grand",
            "id": "host-game-begin-any-3"
        },
        {
            "cue": "phase.enter",
            "when": "role-reveal",
            "text": "Look at your phone, and only your phone. Your face is about to give you away.",
            "tone": "ominous",
            "id": "host-phase-enter-role-reveal-1"
        },
        {
            "cue": "phase.enter",
            "when": "role-reveal",
            "text": "Your role is waiting. Read it, then put on your most innocent expression.",
            "tone": "ominous",
            "id": "host-phase-enter-role-reveal-2"
        },
        {
            "cue": "phase.enter",
            "when": "breakfast",
            "text": "Breakfast is served. Let's see who comes down to eat.",
            "tone": "ominous",
            "id": "host-phase-enter-breakfast-1"
        },
        {
            "cue": "phase.enter",
            "when": "breakfast",
            "text": "Good morning. Count the chairs. Now count the guests.",
            "tone": "ominous",
            "id": "host-phase-enter-breakfast-2"
        },
        {
            "cue": "phase.enter",
            "when": "breakfast",
            "text": "The kettle is on. Somebody may not need a cup.",
            "tone": "ominous",
            "id": "host-phase-enter-breakfast-3"
        },
        {
            "cue": "phase.enter",
            "when": "diaries",
            "text": "Diary time. Tell the camera what you can't tell the table.",
            "tone": "dry",
            "id": "host-phase-enter-diaries-1"
        },
        {
            "cue": "phase.enter",
            "when": "diaries",
            "text": "Find a quiet corner. The camera is the only friend you can trust.",
            "tone": "dry",
            "id": "host-phase-enter-diaries-2"
        },
        {
            "cue": "phase.enter",
            "when": "round-table",
            "text": "Take your seats at the Round Table. Somebody here is an Unfaithful. Find them.",
            "tone": "grand",
            "id": "host-phase-enter-round-table-1"
        },
        {
            "cue": "phase.enter",
            "when": "round-table",
            "text": "The Round Table. Speak plainly. Lie convincingly. Your choice.",
            "tone": "grand",
            "id": "host-phase-enter-round-table-2"
        },
        {
            "cue": "phase.enter",
            "when": "round-table",
            "text": "Sit down. Accuse someone. Mean it.",
            "tone": "grand",
            "id": "host-phase-enter-round-table-3"
        },
        {
            "cue": "phase.enter",
            "when": "vote",
            "text": "The talking is over. Write a name.",
            "tone": "ominous",
            "id": "host-phase-enter-vote-1"
        },
        {
            "cue": "phase.enter",
            "when": "vote",
            "text": "Vote with your head, not your heart. Or don't. I'll enjoy it either way.",
            "tone": "ominous",
            "id": "host-phase-enter-vote-2"
        },
        {
            "cue": "phase.enter",
            "when": "night",
            "text": "Goodnight, Faithful. Lock your doors. Unfaithful, your work begins.",
            "tone": "ominous",
            "family": false,
            "id": "host-phase-enter-night-1"
        },
        {
            "cue": "phase.enter",
            "when": "night",
            "text": "The castle sleeps. Well, most of it.",
            "tone": "ominous",
            "family": false,
            "id": "host-phase-enter-night-2"
        },
        {
            "cue": "phase.enter",
            "when": "night",
            "text": "Night falls on the castle. Unfaithful, choose who leaves us.",
            "tone": "ominous",
            "id": "host-phase-enter-night-3"
        },
        {
            "cue": "phase.enter",
            "when": "night",
            "text": "Lights out. Sleep well, if you can.",
            "tone": "ominous",
            "id": "host-phase-enter-night-4"
        },
        {
            "cue": "phase.enter",
            "when": "endgame",
            "text": "So few of you left. Do you trust each other enough to stop now?",
            "tone": "grand",
            "id": "host-phase-enter-endgame-1"
        },
        {
            "cue": "phase.enter",
            "when": "endgame",
            "text": "The End Game. Say \"end it\" together, and the fortune is yours. If an Unfaithful is still here, it's theirs.",
            "tone": "grand",
            "id": "host-phase-enter-endgame-2"
        },
        {
            "cue": "mission.begin",
            "text": "Tonight's mission. Every coin you win goes in the pot. Every coin you lose, well, ask yourselves why.",
            "tone": "playful",
            "id": "host-mission-begin-any-1"
        },
        {
            "cue": "mission.begin",
            "text": "A mission. Watch who helps, and watch who only looks like they're helping.",
            "tone": "playful",
            "id": "host-mission-begin-any-2"
        },
        {
            "cue": "play.begin",
            "when": "speed-lock",
            "text": "A lock, and a code split between you. Shout your digit, and pray it's the right one.",
            "tone": "playful",
            "id": "host-play-begin-speed-lock-1"
        },
        {
            "cue": "play.begin",
            "when": "speed-lock",
            "text": "Every one of you holds a piece of the code. Somebody's piece may be rotten.",
            "tone": "playful",
            "id": "host-play-begin-speed-lock-2"
        },
        {
            "cue": "play.begin",
            "when": "closest-guess",
            "text": "Numbers. Nobody knows them, so everybody pretends to.",
            "tone": "playful",
            "id": "host-play-begin-closest-guess-1"
        },
        {
            "cue": "play.begin",
            "when": "closest-guess",
            "text": "Guess well, and the middle of the table will save you.",
            "tone": "playful",
            "id": "host-play-begin-closest-guess-2"
        },
        {
            "cue": "play.begin",
            "when": "sort-it",
            "text": "Sixteen pieces, four groups. Argue about it, then sort it.",
            "tone": "playful",
            "id": "host-play-begin-sort-it-1"
        },
        {
            "cue": "play.begin",
            "when": "sort-it",
            "text": "Your tiles, your groups. Be careful who you agree with.",
            "tone": "playful",
            "id": "host-play-begin-sort-it-2"
        },
        {
            "cue": "play.begin",
            "when": "blackout",
            "text": "Watch the screen. Remember everything. Then the lights go out.",
            "tone": "playful",
            "id": "host-play-begin-blackout-1"
        },
        {
            "cue": "play.begin",
            "when": "blackout",
            "text": "Keep your eyes open. I'll be asking questions in the dark.",
            "tone": "playful",
            "id": "host-play-begin-blackout-2"
        },
        {
            "cue": "play.begin",
            "when": "potion-mixer",
            "text": "A potion, and a colour to match. Pour carefully. One heavy hand ruins the lot.",
            "tone": "playful",
            "id": "host-play-begin-potion-mixer-1"
        },
        {
            "cue": "play.begin",
            "when": "potion-mixer",
            "text": "Each of you holds an ingredient. Only together will it be right.",
            "tone": "playful",
            "id": "host-play-begin-potion-mixer-2"
        },
        {
            "cue": "play.begin",
            "when": "seal-pairs",
            "text": "Wax seals, in pairs. Remember where they are, and shout when you do.",
            "tone": "playful",
            "id": "host-play-begin-seal-pairs-1"
        },
        {
            "cue": "play.begin",
            "when": "seal-pairs",
            "text": "Sixteen seals. Your memory against mine.",
            "tone": "playful",
            "id": "host-play-begin-seal-pairs-2"
        },
        {
            "cue": "play.begin",
            "when": "portrait-gallery",
            "text": "Pick up the brush. Some of you are artists. The rest are critics.",
            "tone": "playful",
            "id": "host-play-begin-portrait-gallery-1"
        },
        {
            "cue": "play.begin",
            "when": "portrait-gallery",
            "text": "Draw what you're told. Guess what you see. Taste is optional.",
            "tone": "playful",
            "id": "host-play-begin-portrait-gallery-2"
        },
        {
            "cue": "play.begin",
            "when": "spot-the-change",
            "text": "Study my room. When you look again, five things will be different.",
            "tone": "playful",
            "id": "host-play-begin-spot-the-change-1"
        },
        {
            "cue": "play.begin",
            "when": "spot-the-change",
            "text": "Somebody has been moving my things. Tell me what.",
            "tone": "playful",
            "id": "host-play-begin-spot-the-change-2"
        },
        {
            "cue": "play.begin",
            "when": "link-up",
            "text": "Lanterns, in pairs. Join them up without getting in each other's way.",
            "tone": "playful",
            "id": "host-play-begin-link-up-1"
        },
        {
            "cue": "play.begin",
            "when": "link-up",
            "text": "Share the courtyard. Some of you won't want to.",
            "tone": "playful",
            "id": "host-play-begin-link-up-2"
        },
        {
            "cue": "mission.result",
            "when": "flawless",
            "text": "Flawless. I'm almost suspicious.",
            "tone": "grand",
            "id": "host-mission-result-flawless-1"
        },
        {
            "cue": "mission.result",
            "when": "flawless",
            "text": "Perfect. Either you're all Faithful, or someone is very patient.",
            "tone": "grand",
            "id": "host-mission-result-flawless-2"
        },
        {
            "cue": "mission.result",
            "when": "strong",
            "text": "Very good. Not perfect, but very good.",
            "tone": "dry",
            "id": "host-mission-result-strong-1"
        },
        {
            "cue": "mission.result",
            "when": "strong",
            "text": "A fine effort. The pot is grateful.",
            "tone": "dry",
            "id": "host-mission-result-strong-2"
        },
        {
            "cue": "mission.result",
            "when": "patchy",
            "text": "Patchy. Somebody wasn't pulling their weight. Or was pulling the other way.",
            "tone": "dry",
            "id": "host-mission-result-patchy-1"
        },
        {
            "cue": "mission.result",
            "when": "patchy",
            "text": "Some of you tried. I'm sure you know who didn't.",
            "tone": "dry",
            "id": "host-mission-result-patchy-2"
        },
        {
            "cue": "mission.result",
            "when": "shaky",
            "text": "That was shaky. Bad luck, or bad faith?",
            "tone": "ominous",
            "id": "host-mission-result-shaky-1"
        },
        {
            "cue": "mission.result",
            "when": "shaky",
            "text": "Hardly anything for the pot. Remember who was in charge.",
            "tone": "ominous",
            "id": "host-mission-result-shaky-2"
        },
        {
            "cue": "mission.result",
            "when": "failure",
            "text": "Nothing. Not a coin. Somebody here is delighted.",
            "tone": "ominous",
            "id": "host-mission-result-failure-1"
        },
        {
            "cue": "mission.result",
            "when": "failure",
            "text": "A total failure. I'd look very closely at the happiest face in the room.",
            "tone": "ominous",
            "id": "host-mission-result-failure-2"
        },
        {
            "cue": "mission.result",
            "when": "sabotaged",
            "text": "Something went wrong in there. Things don't go wrong in my castle by accident.",
            "tone": "ominous",
            "id": "host-mission-result-sabotaged-1"
        },
        {
            "cue": "vote.reveal",
            "when": "banished",
            "text": "The castle has spoken. {name}, you're leaving us.",
            "tone": "grand",
            "id": "host-vote-reveal-banished-1"
        },
        {
            "cue": "vote.reveal",
            "when": "banished",
            "text": "{name}. The votes are clear. Say your piece.",
            "tone": "grand",
            "id": "host-vote-reveal-banished-2"
        },
        {
            "cue": "vote.reveal",
            "when": "tie",
            "text": "A tie. Nobody leaves yet. Vote again, and this time, decide.",
            "tone": "dry",
            "id": "host-vote-reveal-tie-1"
        },
        {
            "cue": "vote.reveal",
            "when": "tie",
            "text": "Split down the middle. Try again.",
            "tone": "dry",
            "id": "host-vote-reveal-tie-2"
        },
        {
            "cue": "vote.reveal",
            "when": "draw",
            "text": "Still tied. Fate will choose for you. {name}, I'm afraid it chose you.",
            "tone": "ominous",
            "id": "host-vote-reveal-draw-1"
        },
        {
            "cue": "banishment.reveal",
            "when": "traitor",
            "text": "An Unfaithful. Well done. There may be more.",
            "tone": "grand",
            "id": "host-banishment-reveal-traitor-1"
        },
        {
            "cue": "banishment.reveal",
            "when": "traitor",
            "text": "You found one. Enjoy it. Then ask who defended them.",
            "tone": "grand",
            "id": "host-banishment-reveal-traitor-2"
        },
        {
            "cue": "banishment.reveal",
            "when": "traitor",
            "text": "An Unfaithful, caught. The others will be very quiet now.",
            "tone": "grand",
            "id": "host-banishment-reveal-traitor-3"
        },
        {
            "cue": "banishment.reveal",
            "when": "faithful",
            "text": "Faithful. You've banished one of your own. The Unfaithful thank you.",
            "tone": "ominous",
            "id": "host-banishment-reveal-faithful-1"
        },
        {
            "cue": "banishment.reveal",
            "when": "faithful",
            "text": "Faithful, all along. Somebody steered you there.",
            "tone": "ominous",
            "id": "host-banishment-reveal-faithful-2"
        },
        {
            "cue": "banishment.reveal",
            "when": "faithful",
            "text": "Another Faithful gone. The Unfaithful couldn't have done it better themselves.",
            "tone": "ominous",
            "id": "host-banishment-reveal-faithful-3"
        },
        {
            "cue": "banishment.reveal",
            "when": "secret",
            "text": "{name} leaves, and their secret goes with them.",
            "tone": "ominous",
            "id": "host-banishment-reveal-secret-1"
        },
        {
            "cue": "banishment.reveal",
            "when": "secret",
            "text": "No reveal tonight. You'll have to trust your instincts.",
            "tone": "ominous",
            "id": "host-banishment-reveal-secret-2"
        },
        {
            "cue": "murder.reveal",
            "when": "murdered",
            "text": "{name} won't be joining us. The Unfaithful chose well.",
            "tone": "ominous",
            "family": false,
            "id": "host-murder-reveal-murdered-1"
        },
        {
            "cue": "murder.reveal",
            "when": "murdered",
            "text": "We lost {name} in the night. {fact_line}",
            "tone": "ominous",
            "family": false,
            "id": "host-murder-reveal-murdered-2"
        },
        {
            "cue": "murder.reveal",
            "when": "murdered",
            "text": "{name}'s chair is empty. Somebody at this table knows why.",
            "tone": "ominous",
            "family": false,
            "id": "host-murder-reveal-murdered-3"
        },
        {
            "cue": "murder.reveal",
            "when": "murdered",
            "text": "{name} has left the castle in the night. {fact_line}",
            "tone": "ominous",
            "id": "host-murder-reveal-murdered-4"
        },
        {
            "cue": "murder.reveal",
            "when": "murdered",
            "text": "We said goodbye to {name} while you slept.",
            "tone": "ominous",
            "id": "host-murder-reveal-murdered-5"
        },
        {
            "cue": "murder.reveal",
            "when": "shield",
            "text": "Everyone is here. The Unfaithful chose someone protected. Who held the Shield?",
            "tone": "playful",
            "id": "host-murder-reveal-shield-1"
        },
        {
            "cue": "murder.reveal",
            "when": "shield",
            "text": "A full table. Somebody was protected last night, and they're not telling.",
            "tone": "playful",
            "id": "host-murder-reveal-shield-2"
        },
        {
            "cue": "murder.reveal",
            "when": "none",
            "text": "Everyone survived. The Unfaithful didn't strike. Ask yourselves what they were doing instead.",
            "tone": "playful",
            "id": "host-murder-reveal-none-1"
        },
        {
            "cue": "murder.reveal",
            "when": "none",
            "text": "All present. Either the Unfaithful were busy, or they were careless.",
            "tone": "playful",
            "id": "host-murder-reveal-none-2"
        },
        {
            "cue": "game.end",
            "when": "faithful",
            "text": "The Faithful win. Every one of the Unfaithful found. Every coin is yours.",
            "tone": "grand",
            "id": "host-game-end-faithful-1"
        },
        {
            "cue": "game.end",
            "when": "faithful",
            "text": "It's over. The Faithful held their nerve, and the fortune is theirs.",
            "tone": "grand",
            "id": "host-game-end-faithful-2"
        },
        {
            "cue": "game.end",
            "when": "traitor",
            "text": "The Unfaithful win. You sat with them, laughed with them, and handed them the fortune.",
            "tone": "grand",
            "id": "host-game-end-traitor-1"
        },
        {
            "cue": "game.end",
            "when": "traitor",
            "text": "Congratulations, Unfaithful. The rest of you, look who you trusted.",
            "tone": "grand",
            "id": "host-game-end-traitor-2"
        },
        {
            "cue": "diary.play",
            "when": "sealed",
            "text": "Before you go, the confessions they kept from you.",
            "tone": "ominous",
            "id": "host-diary-play-sealed-1"
        },
        {
            "cue": "diary.play",
            "when": "sealed",
            "text": "Some diaries were sealed until tonight. Let's hear them.",
            "tone": "ominous",
            "id": "host-diary-play-sealed-2"
        },
        {
            "cue": "shield.begin",
            "when": "temptation",
            "text": "There is a Shield in this chest. Reach in, if you dare. But every hand that reaches takes gold from all of you.",
            "tone": "ominous",
            "id": "host-shield-begin-temptation-0"
        },
        {
            "cue": "shield.begin",
            "when": "temptation",
            "text": "A Shield, for one of you. Each hand that reaches for it costs the pot. Choose on your phone, and choose alone.",
            "tone": "dry",
            "id": "host-shield-begin-temptation-1"
        },
        {
            "cue": "shield.begin",
            "when": "one-hand",
            "text": "One Shield. Claim it, and everyone will see. If two of you reach for it, it shatters, and nobody is safe.",
            "tone": "grand",
            "id": "host-shield-begin-one-hand-2"
        },
        {
            "cue": "shield.begin",
            "when": "one-hand",
            "text": "Who wants to live? Claim the Shield in front of everyone. But only one hand may take it.",
            "tone": "ominous",
            "id": "host-shield-begin-one-hand-3"
        },
        {
            "cue": "shield.begin",
            "when": "bargain",
            "text": "One of you is being offered a Shield. Right now. In secret. The price is your friends' gold.",
            "tone": "ominous",
            "id": "host-shield-begin-bargain-4"
        },
        {
            "cue": "shield.begin",
            "when": "bargain",
            "text": "Look at your phone. One of you has an offer waiting. Everyone else: watch their faces.",
            "tone": "playful",
            "id": "host-shield-begin-bargain-5"
        },
        {
            "cue": "shield.result",
            "when": "temptation-won",
            "text": "{takers} reached in. {gold} gold is gone. And one of those hands now holds a Shield.",
            "tone": "ominous",
            "id": "host-shield-result-temptation-won-6"
        },
        {
            "cue": "shield.result",
            "when": "temptation-none",
            "text": "Not one hand reached in. The gold is safe. Nobody is.",
            "tone": "dry",
            "id": "host-shield-result-temptation-none-7"
        },
        {
            "cue": "shield.result",
            "when": "one-hand-won",
            "text": "{name} claimed it, and nobody stood in their way. The Shield is theirs.",
            "tone": "grand",
            "id": "host-shield-result-one-hand-won-8"
        },
        {
            "cue": "shield.result",
            "when": "one-hand-shattered",
            "text": "{takers} reached for it at once. The Shield shatters. Greed protects no one.",
            "tone": "ominous",
            "id": "host-shield-result-one-hand-shattered-9"
        },
        {
            "cue": "shield.result",
            "when": "one-hand-none",
            "text": "Nobody dared claim it. Modest. Or afraid of being seen.",
            "tone": "dry",
            "id": "host-shield-result-one-hand-none-10"
        },
        {
            "cue": "shield.result",
            "when": "bargain-taken",
            "text": "The deal is done. {gold} gold has left the pot, and someone among you is a little safer tonight.",
            "tone": "ominous",
            "id": "host-shield-result-bargain-taken-11"
        },
        {
            "cue": "shield.result",
            "when": "bargain-refused",
            "text": "The offer was refused. The gold stays. Whoever it was, they chose the group. Or wanted you to think so.",
            "tone": "dry",
            "id": "host-shield-result-bargain-refused-12"
        }
    ],
    "clips": [],
    "arcs": [
        {
            "id": "the-inheritance",
            "title": "The Inheritance",
            "synopsis": "The old Lord of the castle is dead, and his fortune goes to whoever remains. Someone among you has already decided who that will be.",
            "locations": [
                "the library",
                "the stables",
                "the chapel",
                "the long gallery",
                "the wine cellar",
                "the east tower"
            ]
        }
    ]
}
